var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('div',{attrs:{"id":"kefu-contain"}},[_c('drag',{attrs:{"id":'drag-contain'}},[_c('img',{staticClass:"kefu",attrs:{"id":"customerService","src":require("../assets/images/kefu-icon.png")},on:{"click":_vm.toChat}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }